export class utilities {
  /**
   * Get the bank name from url and return. For new bank/corp add the condition here
   *
   * @returns Bank name
   */
  static getBankName() {
    let hostname = window.location.hostname;
    if (hostname.toLowerCase().includes('chegcalendar')) {
      return 'KEGB';
    } else if (hostname.toLowerCase().includes('canara')) {
      return 'CANARA';
    } else if (hostname.toLowerCase().includes('kegb')) {
      return 'KEGB';
    } else if (hostname.toLowerCase().includes('kagb')) {
      return 'KAGB';
    } else {
      return 'KEGB';
    }
    return 'CANARA';
  }
}
